import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"
import "../../newcomponents/index.css"

const MonthlyEarnings = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const [doctors, setDoctors] = useState([])
  const [reviews, setReviews] = useState([])
  const [chartData, setChartData] = useState({
    options: {
      colors: ["#2990DF", "#F0F1F4"],
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "70%",
        },
      },
      grid: {
        borderColor: "#f8f8fa",
        row: {
          colors: ["transparent", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [], // Months
        labels: {
          formatter: function (val) {
            return val
          },
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: undefined,
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val
          },
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
        position: "top",
        horizontalAlign: "left",
        offsetX: 40,
      },
    },
    series: [
      {
        name: "Average Rating",
        data: [],
      },
    ],
  })
  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getReviews?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
    }
  }
  const fetchDoctors = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getDoctors?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setDoctors(response.data.doctors)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchDoctors()
    fetchReviews()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    // Process reviews to get last 12 months' data
    const trends = {}
    const months = new Set()

    reviews.forEach(review => {
      const reviewMonth = new Date(review.reviewDate).toLocaleString(
        "default",
        { month: "short", year: "numeric" },
      )

      months.add(reviewMonth)

      if (!trends[reviewMonth]) {
        trends[reviewMonth] = { totalRating: 0, reviewCount: 0 }
      }

      trends[reviewMonth].totalRating += review.rating
      trends[reviewMonth].reviewCount += 1
    })

    // Sort and get the last 12 months
    const sortedMonths = Array.from(months)
      .sort((a, b) => new Date(a) - new Date(b))
      .slice(-12)

    // Calculate average ratings for each month
    const ratings = sortedMonths.map(month => {
      const monthData = trends[month]
      return monthData ? monthData.totalRating / monthData.reviewCount : 0 // Default to 0 if no data
    })

    // Update chart data
    setChartData(prevData => ({
      ...prevData,
      options: {
        ...prevData.options,
        xaxis: {
          ...prevData.options.xaxis,
          categories: sortedMonths,
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              // Convert the value to a fixed 2-decimal string
              return val.toFixed(1)
            },
          },
        },
      },
      series: [
        {
          name: "Average Rating",
          data: ratings,
        },
      ],
    }))
  }, [reviews, doctors, isConsolidatedView, organizations])

  return (
    <React.Fragment>
      <Card className="br">
        <CardBody>
          <h4 className="card-title mb-4">Monthly Ratings</h4>

          <Row className="text-center mt-4">
            <Col xs="6">
              <h5 className="font-size-20">{reviews.length}</h5>
              <p className="text-muted">Total Reviews</p>
            </Col>
            <Col xs="6">
              <h5 className="font-size-20">
                {(
                  reviews.reduce((sum, review) => sum + review.rating, 0) /
                  (reviews.length || 1)
                ).toFixed(1)}
              </h5>
              <p className="text-muted">Average Rating</p>
            </Col>
          </Row>

          <div
            id="morris-bar-stacked"
            className="morris-charts morris-charts-height"
            dir="ltr"
          >
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height="290"
              style={{
                color: "#2990DF",
              }}
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
